module.exports = __webpack_public_path__ + "images/backgrounds/canyon/small.1478a9382a5ab8c49368.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/canyon/small.jpg
// module id = pL+5
// module chunks = 24